<template>
  <div v-if="isLoadingFinish">
    <template v-if="products.length && (productsDesktop.length || productsMobile.length)">
      <div class="section--banner section--banner-loading element-placeholder">
        <carousel
          v-if="isDesktop"
          :per-page="1"
          :autoplay="true"
          :autoplay-timeout="4000"
          :pagination-color="'#FFFFFF'"
          :pagination-active-color="'#F083A6'"
          :navigation-enabled="true"
          :navigation-click-target-size="0"
          loop
          navigation-next-label
          navigation-prev-label
        >
          <slide v-for="(product, key) in productsDesktop" :key="`desktop${key}`" class="slides">
            <a :href="product.url" class="banner-primary">
              <img
                :src="mainImage(product.image) || ''"
                :alt="product.name"
                fetchpriority="high"
                width="815"
                heigth="297"
                :loading="key == 0 ? 'eager' : 'lazy'"
              />
            </a>
          </slide>
        </carousel>

        <div v-else class="slide-mob">
          <carousel
            :per-page="1"
            :autoplay="true"
            :autoplay-timeout="4000"
            :pagination-color="'#FFFFFF'"
            :pagination-active-color="'#F083A6'"
            :navigation-enabled="false"
            :navigation-click-target-size="0"
            loop
          >
            <slide v-for="(product, key) in productsDesktop" :key="`mobile${key}`" class="slides">
              <a :href="product.url" class="banner-primary">
                <img
                  :src="mainImage(product.image) || ''"
                  :alt="product.name"
                  fetchpriority="high"
                  width="300"
                  heigth="113"
                  :loading="key == 0 ? 'eager' : 'lazy'"
                />
              </a>
            </slide>
          </carousel>
        </div>
      </div>
    </template>
  </div>
  <div v-else>
    <div class="section--banner section--banner-loading element-placeholder">
      <carousel :per-page="1" :navigation-enabled="false" :pagination-enabled="false">
        <slide>
          <GFMP :styles="{ minHeight: '192px', width: '100%' }" />
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'block-banner-home',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    classModifier: {
      type: String,
      required: false,
    },
    products: {
      type: Array,
      required: true,
    },
    isLoadingFinish: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    productsDesktop() {
      return this.products.filter((b) => b.screen_type === 'desktop-web');
    },
    productsMobile() {
      return this.products.filter((b) => b.screen_type === 'mobile-web');
    },
  },
  methods: {
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=815' : 'w=300',
        image: src,
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
